import type {
  ExtranetIncidentsListInput,
  ExtranetInvoicesListInput,
  ExtranetRidesListInput,
  ExtranetUsersListInput,
  DashboardRateInput,
  VolumeIncidentsInterval,
} from '../../types/extranet-api.types';

export const extranetQueryKeys = {
  account: {
    me: () => ['extranet', 'account', 'me'] as const,
    permissions: () => ['extranet', 'account', 'permissions'] as const,
    config: () => ['extranet', 'account', 'config'] as const,
  },
  scope: {
    entities: () => ['extranet', 'scope', 'entities'] as const,
    contracts: (entityIds: string[] | undefined) => ['extranet', 'scope', 'contracts', entityIds ?? []] as const,
    sites: (contractIds: string[] | undefined) => ['extranet', 'scope', 'sites', contractIds ?? []] as const,
  },
  dashboard: {
    rate: (metric: string, input: DashboardRateInput) => ['extranet', 'dashboard', 'rate', metric, input] as const,
    incidentCategoryBuckets: (input: DashboardRateInput) =>
      ['extranet', 'dashboard', 'incident-category-buckets', input] as const,
    incidentTimeSeries: (input: DashboardRateInput & { interval?: VolumeIncidentsInterval }) =>
      ['extranet', 'dashboard', 'incident-timeseries', input] as const,
    notes: (input: DashboardRateInput) => ['extranet', 'dashboard', 'dashboard-notes', input] as const,
  },
  rides: {
    list: (input: ExtranetRidesListInput) => ['extranet', 'rides', 'list', input] as const,
  },
  incidents: {
    list: (input: ExtranetIncidentsListInput) => ['extranet', 'incidents', 'list', input] as const,
    detail: (id: string) => ['extranet', 'incidents', 'detail', id] as const,
  },
  performance: {
    punctualityDistribution: (input: DashboardRateInput) =>
      ['extranet', 'performance', 'punctuality-distribution', input] as const,
    compare: (input: DashboardRateInput & { dimension: string }) =>
      ['extranet', 'performance', 'compare', input] as const,
  },
  invoices: {
    list: (input: ExtranetInvoicesListInput) => ['extranet', 'invoices', 'list', input] as const,
    detail: (id: string) => ['extranet', 'invoices', 'detail', id] as const,
  },
  users: {
    list: (input: ExtranetUsersListInput) => ['extranet', 'users', 'list', input] as const,
    detail: (id: string) => ['extranet', 'users', 'detail', id] as const,
  },
};
